'use client';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { Mail, ArrowRight } from 'lucide-react';

interface FormData {
  email: string;
}

export default function EmailCapture() {
  const [submitted, setSubmitted] = useState(false);
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<FormData>();

  const onSubmit = async (data: FormData) => {
    // TODO: Connect to email marketing service (Mailchimp, ConvertKit, etc.)
    await new Promise(r => setTimeout(r, 800));
    setSubmitted(true);
    toast.success('Добавлено! Следите за новым контентом.');
  };

  return (
    <section className="py-20 px-6 lg:px-10" style={{ backgroundColor: 'var(--pub-bg)' }}>
      <div className="max-w-2xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#E8E0D0] mb-6">
          <Mail size={20} className="text-[#7A7060]" />
        </div>
        <h2
          className="text-2xl md:text-3xl font-300 text-[#1C1710] mb-4"
          style={{ fontWeight: 300, letterSpacing: '-0.01em' }}
        >
          Новые видео — первым
        </h2>
        <p className="text-[#7A7060] mb-8 text-sm leading-relaxed">
          Без спама. Только когда выходит что-то настоящее.
        </p>

        {submitted ? (
          <div className="flex items-center justify-center gap-3 py-4 px-6 rounded-full bg-[#E8F0E8] text-[#5A7A5A] text-sm">
            <div className="w-2 h-2 rounded-full bg-[#5A7A5A]" />
            Готово — вы в списке
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <div className="flex-1">
              <input
                type="email"
                placeholder="ваш@email.com"
                {...register('email', {
                  required: 'Введите email',
                  pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Неверный формат' },
                })}
                className="w-full px-5 py-3.5 rounded-full border text-sm outline-none transition-all duration-200 focus:border-[#1C1710]"
                style={{
                  borderColor: errors.email ? '#DC2626' : 'var(--pub-border)',
                  background: 'white',
                  color: 'var(--pub-text)',
                }}
              />
              {errors.email && (
                <p className="text-red-500 text-xs mt-1.5 ml-4">{errors.email.message}</p>
              )}
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#1C1710] text-[#F5F0E8] text-sm font-500 hover:opacity-85 transition-all duration-200 active:scale-95 disabled:opacity-50 min-w-[140px]"
            >
              {isSubmitting ? (
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <>
                  Подписаться
                  <ArrowRight size={14} />
                </>
              )}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}